// targetRoles role = Object that may contain a 'ta', 'instructor', 'student' key
export default function hasRole(user = {}, targetRoles = {}) {
  if (!user.role) return false;
  return !!targetRoles[user.role];
}
